export const rpcInputKindByMethod = {
    0: undefined, // UNSPECIFIED
    1: "getMe",
    2: "sendMessage",
    3: "getPeerPhoto",
    4: "deleteMessages",
    5: "getChatHistory",
    6: "addReaction",
    7: "deleteReaction",
    8: "editMessage",
    9: "createChat",
    10: "getSpaceMembers",
    11: "deleteChat",
    12: "inviteToSpace",
    13: "getChatParticipants",
    14: "addChatParticipant",
    15: "removeChatParticipant",
    16: "translateMessages",
    17: "getChats",
    18: "updateUserSettings",
    19: "getUserSettings",
    20: "sendComposeAction",
    21: "createBot",
    22: "deleteMember",
    23: "markAsUnread",
    24: "getUpdatesState",
    25: "getChat",
    26: "getUpdates",
    27: "updateMemberAccess",
    28: "searchMessages",
    29: "forwardMessages",
    30: "updateChatVisibility",
    31: "pinMessage",
    32: "updateChatInfo",
    33: "listBots",
    34: "revealBotToken",
    35: "moveThread",
    36: "rotateBotToken",
    37: "updateBotProfile",
    38: "getMessages",
    56: "setBotAvatar",
    57: "clearBotAvatar",
    58: "getBotPresence",
    59: "setBotPresenceState",
    48: "invokeMessageAction",
    49: "answerMessageAction",
    53: "clearChatHistory",
    61: "getSessions",
    62: "checkUsername",
    63: "changeUsername",
    64: "updateProfile",
    76: "getPeerBots",
    77: "getMyBotCapabilities",
    78: "setMyBotCapabilities",
    79: "requestBotChatSettings",
    80: "invokeBotChatSettingsItem",
    81: "answerBotChatSettings",
    117: "createUpload",
    118: "saveUploadPart",
    119: "getUploadState",
    120: "finishUpload",
    121: "cancelUpload",
    127: "getSpace",
};
export const rpcResultKindByMethod = {
    0: undefined, // UNSPECIFIED
    1: "getMe",
    2: "sendMessage",
    3: "getPeerPhoto",
    4: "deleteMessages",
    5: "getChatHistory",
    6: "addReaction",
    7: "deleteReaction",
    8: "editMessage",
    9: "createChat",
    10: "getSpaceMembers",
    11: "deleteChat",
    12: "inviteToSpace",
    13: "getChatParticipants",
    14: "addChatParticipant",
    15: "removeChatParticipant",
    16: "translateMessages",
    17: "getChats",
    18: "updateUserSettings",
    19: "getUserSettings",
    20: "sendComposeAction",
    21: "createBot",
    22: "deleteMember",
    23: "markAsUnread",
    24: "getUpdatesState",
    25: "getChat",
    26: "getUpdates",
    27: "updateMemberAccess",
    28: "searchMessages",
    29: "forwardMessages",
    30: "updateChatVisibility",
    31: "pinMessage",
    32: "updateChatInfo",
    33: "listBots",
    34: "revealBotToken",
    35: "moveThread",
    36: "rotateBotToken",
    37: "updateBotProfile",
    38: "getMessages",
    56: "setBotAvatar",
    57: "clearBotAvatar",
    58: "getBotPresence",
    59: "setBotPresenceState",
    48: "invokeMessageAction",
    49: "answerMessageAction",
    53: "clearChatHistory",
    61: "getSessions",
    62: "checkUsername",
    63: "changeUsername",
    64: "updateProfile",
    76: "getPeerBots",
    77: "getMyBotCapabilities",
    78: "setMyBotCapabilities",
    79: "requestBotChatSettings",
    80: "invokeBotChatSettingsItem",
    81: "answerBotChatSettings",
    117: "createUpload",
    118: "saveUploadPart",
    119: "getUploadState",
    120: "finishUpload",
    121: "cancelUpload",
    127: "getSpace",
};
